import { CGProduct } from 'types/shopify';
import { serverErrorMessage } from 'utilities/constants';
import { getShopifyProductByHandle } from 'lib/amplify';
import { useQuery, QueryClient } from 'react-query';

interface ProductHookError {
  message: string;
}

interface ProductHookState {
  product: CGProduct | undefined;
  error: ProductHookError | undefined;
}

const getProduct = (handle: string | undefined) => async () => {
  if (!handle) {
    return undefined;
  }
  const p: CGProduct = await getShopifyProductByHandle(handle);
  if (!p) throw new Error('NOT_FOUND');
  return p;
};

const queryKey = (handle: string | undefined) => ['product', handle];

// prefetchProducts can be used to populate the React Query cache with products that we know we will need at a later stage.
export const prefetchProducts = async (queryClient: QueryClient, handles: string[]) => {
  handles.forEach((handle) => queryClient.prefetchQuery(queryKey(handle), getProduct(handle)));
};

// useProduct uses React Query to cache product requests.
export const useProduct = (handle: string | undefined): ProductHookState => {
  const { data, error } = useQuery(queryKey(handle), getProduct(handle));
  const errorObj = error ? { message: (error as Error).message || serverErrorMessage } : undefined;
  return { product: data, error: errorObj };
};
